<script setup lang="ts">
import { ref, watchEffect } from "vue";

import ClaimSelect from "./ClaimSelect.vue";
import CustomMessageClaim from "./CustomMessageClaim.vue";
import MissingProductClaim from "./MissingProductClaim.vue";
import Dialog from "@/components/ui/Dialog.vue";

const props = defineProps<{
  disabled?: boolean;
  receiptStatus?: string;
}>();

const emit = defineEmits<{
  (e: "missingProductClaim"): void;
  (e: "otherClaim"): void;
}>();

const model = defineModel<"missingPoints" | "missingProduct" | "other" | null>({ required: true });
const open = defineModel<boolean>("open");

const message = ref("");

function onClose() {
  if (model.value && model.value !== "missingPoints") {
    model.value = null;
  }
}

function handleClose() {
  model.value = null;
  // For completed/rejected receipts, close the dialog completely
  if (props.receiptStatus === "completed" || props.receiptStatus === "rejected") {
    open.value = false;
  }
}

watchEffect(() => {
  if (model.value === "missingPoints") {
    open.value = false;
  }
});
</script>

<template>
  <Dialog v-model:open="open" @update:open="onClose">
    <template #content>
      <ClaimSelect v-if="!model" v-model="model" />

      <MissingProductClaim
        v-else-if="model === 'missingProduct'"
        @sent="emit('missingProductClaim')"
        @close="model = null"
      />

      <CustomMessageClaim
        v-else-if="model === 'other'"
        v-model="message"
        :receiptStatus="props.receiptStatus"
        @sent="emit('otherClaim')"
        @close="handleClose"
      />
    </template>
  </Dialog>
</template>
